import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
interface AudioPlayerState {
  route: any;
  show: boolean;
  details: any;
}
interface RecordingPanelState {
  show: boolean;
  details: any;
  gridName: string
}

@Injectable({
  providedIn: 'root',
})
export class AgentCallEvaluationService {
  constructor(private httpClient: HttpClient, public authService: AuthenticationService) {}

  private showRecordingDetailsSidebar = new BehaviorSubject<RecordingPanelState>({
    show: false,
    details: null,
    gridName:''
  });

  private audioPlayer = new BehaviorSubject<AudioPlayerState>({
    route: null,
    show: false,
    details: null,
  });

  private isDraggable = new BehaviorSubject<boolean>(false);
  private isToggleSidebar = new BehaviorSubject<boolean>(false);


  public showRecordingDetailsSidebar$: Observable<RecordingPanelState> = this.showRecordingDetailsSidebar.asObservable();
  public audioPlayerState$: Observable<AudioPlayerState> = this.audioPlayer.asObservable();
  public isDraggable$: Observable<boolean> = this.isDraggable.asObservable();
  public isToggleSidebar$: Observable<boolean> = this.isToggleSidebar.asObservable();

  setShowRecordingDetailsSidebar(show: boolean, details: any, gridName: string): void {
    this.showRecordingDetailsSidebar.next({ show, details, gridName });
  }

  setAudioPlayerState(route: any, show: boolean, details: any): void {
    this.audioPlayer.next({ route, show, details });
  }

  setAudioPlayerDraggable(pin: boolean): void {
    this.isDraggable.next(pin);
  }

  setSidebarToggle(toggle: boolean): void {
    this.isToggleSidebar.next(toggle);
  }

  getQuestions() {
    let url = `/evaluation`;
    return this.httpClient.get(url);
  }

  getSaveEvaluationDetails(CallSid: string) {
    let url = `/evaluation/getEvaluationForm?CallSid=${CallSid}`;
    return this.httpClient.get(url);
  }

  postEvaluationData(data: any) {
    let url = `/evaluation`;
    return this.httpClient.post(url, data);
  }

  updateEvaluationData(data: any) {
    let url = `/evaluation/updateStatus`;
    return this.httpClient.post(url, data);
  }
  uploadFile(data: any) {
    let url = `/evaluation/upload`;
    return this.httpClient.post(url, data);
  }
  DownloadFile(fileName: string): Observable<HttpResponse<object>> {
    return this.httpClient.get(`/evaluation/download?fileName=${fileName}`, {
      responseType: 'blob' as 'json',
      observe: 'response',
    });
  }
  getAllDispositionsData() {
    let url = `/dispositions`;
    return this.httpClient.get(url);
  }
  getAllCallsData(payload: any) {
    let authData = this.authService.authData;
    //* For Sup Only show report to users
    //* For QA show all users
    if (!authData?.QA) {
      payload.IsSupUsersOnly = true;
    }
    let url = `/recordings/calls`;
    return this.httpClient.post(url, payload);
  }
  getApprovalList(
    startDate: string,
    endDate: string,
    fields: string,
    fieldValues: string,
    criteria: string,
    limit: Number,
    skip: Number,
    isSupervisor: boolean,
    adv_filters?: any[],
    search_meta?: any[],
    sort_meta?: any,
    ...additionalOptions: any) {

    let url = `/evaluation/get`;
    const payload = {
      Sightline: {
        StartDate: startDate,
        EndDate: endDate,
        Fields: fields,
        FieldValues: fieldValues,
        Criteria: criteria,
        Limit: limit,
        Skip: skip,
        AdvFilters: adv_filters,
        SearchMeta: search_meta,
        SortMeta: sort_meta,
      },
      isSupervisor,
    };
    return this.httpClient.post(url, payload);
  }
}
